/**
 * Shared SSE (Server-Sent Events) stream parser.
 *
 * Extracts the common streaming pattern used by ChatContext, BibleContext,
 * and PrayerGenerator into a single reusable function.
 *
 * @param {Response} res - Fetch response with readable body stream
 * @param {(event: Object) => void} onEvent - Called for each parsed SSE event
 * @returns {Promise<void>} Resolves when stream ends
 */
export async function parseSSEStream(res, onEvent) {
  const reader = res.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split('\n')
    buffer = lines.pop() || ''

    for (const line of lines) {
      if (!line.startsWith('data: ')) continue
      try {
        const data = JSON.parse(line.slice(6))
        onEvent(data)
      } catch {
        // skip malformed SSE lines
      }
    }
  }
}
